export enum RunViewState {
  RUNNING = 'RUNNING',
  NEEDS_PLAN_APPROVAL = 'NEEDS_PLAN_APPROVAL',
  NEEDS_ACTION_APPROVAL = 'NEEDS_ACTION_APPROVAL',
  NEEDS_INPUT = 'NEEDS_INPUT',
  WAITING_REPLY = 'WAITING_REPLY',
  DONE_PR = 'DONE_PR',
  DONE = 'DONE',
  DECLINED = 'DECLINED',
  FAILED = 'FAILED',
  ENDED = 'ENDED',
}

export enum RunViewTone {
  NEUTRAL = 'NEUTRAL',
  AMBER = 'AMBER',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  RED = 'RED',
}

export enum RunViewMeta {
  PLAN_READY = 'PLAN_READY',
  UPDATE_READY = 'UPDATE_READY',
  ACTION_READY = 'ACTION_READY',
  STOPPED_ON_STEP = 'STOPPED_ON_STEP',
  DECLINED_BY_OWNER = 'DECLINED_BY_OWNER',
  ENDED_BY_USER = 'ENDED_BY_USER',
  REPLACED = 'REPLACED',
}
